import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72904277&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72904277",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72904277')) {
      api.createRecord('72904277', component.options)
    } else {
      api.reload('72904277', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72904277&scoped=true", function () {
      api.rerender('72904277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/logistics/strategy/assignGoods/index.vue"
export default component.exports